"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const icon_names_1 = require("@/components/common/icon/icon-names");
const link_styles_1 = require("@/components/common/link/link.styles");
require("@/components/common/icon");
const shared_styles_1 = require("@/stylesheets/shared.styles");
let Link = class Link extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.href = '';
        this.target = '';
        this.external = false;
    }
    render() {
        const tempTarget = this.external ? '_blank' : '_self';
        return (0, lit_1.html) `
      <a
        class="link"
        href=${this.href}
        target=${tempTarget}
        rel=${this.external ? 'noopener noreferrer' : lit_1.nothing}
      >
        <slot></slot>
        ${this.renderExternalIcon()}
      </a>
    `;
    }
    renderExternalIcon() {
        if (!this.external)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-icon name=${icon_names_1.ICON_NAMES.LINK}></mm-icon>
    `;
    }
};
Link.styles = [shared_styles_1.resetStyles, link_styles_1.linkStyles];
__decorate([
    (0, decorators_js_1.property)({ type: String })
], Link.prototype, "href", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], Link.prototype, "target", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], Link.prototype, "external", void 0);
Link = __decorate([
    (0, decorators_js_1.customElement)('mm-link')
], Link);
exports.Link = Link;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGluay5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImxpbmsudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQStDO0FBQy9DLHFEQUEyRDtBQUUzRCxvRUFBZ0U7QUFDaEUsc0VBQWlFO0FBQ2pFLG9DQUFpQztBQUNqQywrREFBeUQ7QUFHbEQsSUFBTSxJQUFJLEdBQVYsTUFBTSxJQUFLLFNBQVEsZ0JBQVU7SUFBN0I7O1FBRXVCLFNBQUksR0FBRyxFQUFFLENBQUE7UUFDVCxXQUFNLEdBQUcsRUFBRSxDQUFBO1FBQ1YsYUFBUSxHQUFHLEtBQUssQ0FBQTtJQXdCL0MsQ0FBQztJQXRCQyxNQUFNO1FBQ0osTUFBTSxVQUFVLEdBQUcsSUFBSSxDQUFDLFFBQVEsQ0FBQyxDQUFDLENBQUMsUUFBUSxDQUFDLENBQUMsQ0FBQyxPQUFPLENBQUE7UUFDckQsT0FBTyxJQUFBLFVBQUksRUFBQTs7O2VBR0EsSUFBSSxDQUFDLElBQUk7aUJBQ1AsVUFBVTtjQUNiLElBQUksQ0FBQyxRQUFRLENBQUMsQ0FBQyxDQUFDLHFCQUFxQixDQUFDLENBQUMsQ0FBQyxhQUFPOzs7VUFHbkQsSUFBSSxDQUFDLGtCQUFrQixFQUFFOztLQUU5QixDQUFBO0lBQ0gsQ0FBQztJQUVPLGtCQUFrQjtRQUN4QixJQUFJLENBQUMsSUFBSSxDQUFDLFFBQVE7WUFBRSxPQUFPLGFBQU8sQ0FBQTtRQUVsQyxPQUFPLElBQUEsVUFBSSxFQUFBO3NCQUNPLHVCQUFVLENBQUMsSUFBSTtLQUNoQyxDQUFBO0lBQ0gsQ0FBQzs7QUExQk0sV0FBTSxHQUFHLENBQUMsMkJBQVcsRUFBRSx3QkFBVSxDQUFDLENBQUE7QUFDYjtJQUEzQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUM7a0NBQVU7QUFDVDtJQUEzQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUM7b0NBQVk7QUFDVjtJQUE1QixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsT0FBTyxFQUFFLENBQUM7c0NBQWlCO0FBSmxDLElBQUk7SUFEaEIsSUFBQSw2QkFBYSxFQUFDLFNBQVMsQ0FBQztHQUNaLElBQUksQ0E0QmhCO0FBNUJZLG9CQUFJIn0=